<template>
  <div>

    <d-card class="mb-5">
      <d-card-header class="pr-3 pl-3">
        <b-card-title class="h4 mb-0">Menu boczne</b-card-title>
      </d-card-header>

      <d-card-body class="pl-3">
        <b-row>
          <b-col>
            <label class="h6">Linie między opcjami</label>
            <b-form-checkbox
              class="ml-2 mr-sm-2 mb-sm-0"
              v-model='$store.state.fanzones.form.doc.sideMenu.separators.show'
            />
          </b-col>

          <b-col>
            <label class="h6">Kolor linii</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.sideMenu.separators.color'
            />
          </b-col>

          <b-col>
            <label class="h6">Grubość linii</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.sideMenu.separators.size'
              size='sm'
            />
          </b-col>

          <b-col>
            <label class="h6">Kropki przed nazwą opcji</label>
            <b-form-checkbox
              class="ml-2 mr-sm-2 mb-sm-0"
              v-model='$store.state.fanzones.form.doc.sideMenu.dots.show'
            />
          </b-col>
        </b-row>
      </d-card-body>
    </d-card>

    <d-card class="mb-5">
      <d-card-header class="pr-3 pl-3">
        <b-card-title class="h4 mb-0">Newsy</b-card-title>
      </d-card-header>

      <d-card-body class="pl-3">
        <b-row>
          <b-col cols="2">
            <label class="h6">Zaokrąglenie</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.news.borderRadius'
              size='sm'
            />
          </b-col>
        </b-row>
      </d-card-body>
    </d-card>

    <d-card class="mb-5">
      <d-card-header class="pr-3 pl-3">
        <b-card-title class="h4 mb-0">Glosowanie</b-card-title>
      </d-card-header>

      <d-card-body class="pl-3">
        <b-row>
          <b-col cols="12"><h4>Karta wydarzenia</h4></b-col>

          <b-col cols="2">
            <label class="h6">Zaokrąglenie</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.voting.eventCard.borderRadius'
              size='sm'
            />
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12"><h4>Button</h4></b-col>

          <b-col cols="2">
            <label class="h6">Zaokrąglenie</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.voting.eventCard.button.borderRadius'
              size='sm'
            />
          </b-col>
          <b-col>
            <label class="h6">Zagłosowano - tło</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.voting.eventCard.button.voted.backgroundColor'
              
            />
          </b-col>
          <b-col>
            <label class="h6">Zagłosowano - tekst</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.voting.eventCard.button.voted.textColor'
            />
          </b-col>
          <b-col>
            <label class="h6">Nie zagłosowano - tło</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.voting.eventCard.button.unvoted.backgroundColor'
            />
          </b-col>
          <b-col>
            <label class="h6">Nie zagłosowano - tekst</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.voting.eventCard.button.unvoted.textColor'
            />
          </b-col>
        </b-row>
      </d-card-body>
    </d-card>

    <d-card class="mb-5">
      <d-card-header class="pr-3 pl-3">
        <b-card-title class="h4 mb-0">Program</b-card-title>
      </d-card-header>

      <d-card-body>
        <b-row>
          <b-col cols="12"><h4>Menu</h4></b-col>

          <b-col cols="">
            <label class="h6">Zaokrąglenie</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.program.menu.borderRadius'
              size='sm'
            />
          </b-col>

          <b-col>
            <label class="h6">Separator</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.menu.lineColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Aktywny - tło</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.menu.active.backgroundColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Aktywny - tekst</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.menu.active.textColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Nieaktywny - tło</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.menu.inactive.backgroundColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Nieaktywny - tekst</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.menu.inactive.textColor'
            />
          </b-col>
        </b-row>

        <b-row class="mt-5">
          <b-col cols="12"><h4>Button filtra</h4></b-col>

          <b-col cols="">
            <label class="h6">Zaokrąglenie</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.program.filterButton.borderRadius'
              size='sm'
            />
          </b-col>

          <b-col cols="2">
            <label class="h6">Odstęp</label>
            <b-form-input
              class='form-control'
              type='number'
              v-model='$store.state.fanzones.form.doc.program.filterButton.marginRight'
              size='sm'
            />
          </b-col>

          <b-col>
            <label class="h6">Aktywny - tło</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.filterButton.active.backgroundColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Aktywny - tekst</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.filterButton.active.textColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Nieaktywny - tło</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.filterButton.inactive.backgroundColor'
            />
          </b-col>

          <b-col>
            <label class="h6">Nieaktywny - tekst</label>
            <b-form-input
              class='form-control'
              type='color'
              v-model='$store.state.fanzones.form.doc.program.filterButton.inactive.textColor'
            />
          </b-col>
        </b-row>
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
  export default {
    methods: {
      //doc: this.$store.state.fanzones.form.doc
    },
    computed: {
      //doc() {
//        return this.$store.state.fanzones.form.doc
      //},
    },
  }
</script>